import { defaultCTA } from '../utils/constants'
import { useMemo } from 'react'
import { useIsTrial } from './useIsTrial'

export const useCtaText = ({ lang, market, isTextShort, disableFreeTrial, ctaText }) => {
  market = market === 'all' || market === undefined ? 'us' : market
  const isTrial = useIsTrial(market)

  return useMemo(() => {
    if (ctaText) return ctaText

    // Determine trial text based on settings
    const shouldDisableTrial =
      disableFreeTrial !== null && disableFreeTrial !== undefined ? disableFreeTrial : !isTrial
    const trialText = shouldDisableTrial ? defaultCTA[market].noTrial : defaultCTA[market].freeTrial

    // Return appropriate text based on language and length
    if (lang === 'es') return trialText?.text_es
    if (isTextShort) return trialText?.text_short || trialText?.text
    return trialText?.text
  }, [ctaText, market, isTrial, disableFreeTrial, lang, isTextShort])
}

export const useMarketCtaTexts = ({ lang, isTextShort }) => {
  const isTrial = useIsTrial()

  return useMemo(() => {
    const markets = ['us', 'latino', 'canada']
    const result = {}

    markets.forEach((marketKey) => {
      const trialText = isTrial[marketKey]
        ? defaultCTA[marketKey].freeTrial
        : defaultCTA[marketKey].noTrial

      if (lang === 'es') {
        result[marketKey] = trialText?.text_es
      } else if (isTextShort) {
        result[marketKey] = trialText?.text_short
      } else {
        result[marketKey] = trialText?.text
      }
    })

    return result
  }, [lang, isTextShort, isTrial])
}
